import React, { useContext, useEffect, useState } from "react";
import useScript from "../hooks/useScript";
import { ThemeContext } from "../context/ThemeContext";
import SavedCard from "./SavedCard";
import { httpPost } from "../lib/apiClients";
import { AxiosResponse } from "axios";
import { Environment } from "../utils/environments";
import { useNavigate, useSearchParams } from "react-router-dom";
import exponentialBackoff from "../utils/exponentialBackoff";
import PayJpCardView from "./PayJpCardView";
import PayjpBottom from "./PayjpBottom";
import { setAvailableCardList } from "../utils/payjpUtlis";
import { UserDataContext } from "../context/UserDataContext";
import { isDateFromFuture } from "../lib/dateCalculate";
import { setAnalyticsData } from "../utils/firebaseLog";
import CouponSelectModal from "./CouponSelectModal";
import { cardNameValid } from "../lib/validation";
declare var Payjp: any;
function PayJp({
  chargeData,
  state,
  productId,
  couponData,
  buyType,
  setCoupon,
  concernText,
  concernTextError,
  setConcernTextError,
}) {
  const { getCouponData, setCouponData } = useContext(UserDataContext);
  const [searchParams, setSearchParams] = useSearchParams();
  const [buttonClickable, setButtonClickable] = useState<boolean>(false);
  const [inputEvents, setInputEvents] = useState<any>([]);
  const [cardName, setCardName] = useState<string | undefined>();
  const [saveCard, setSaveCard] = useState<boolean>(false);
  const [useSavedCard, setUseSavedCard] = useState<boolean>(true);
  const [cvvDigits, setCvvDigits] = useState<number>(3);
  const { payjpData, getPurchaseList } = useContext(ThemeContext);
  const [getPayjpData, setPayjpData] = payjpData;
  const { setUserData, fetchCoupon } = useContext(UserDataContext);
  const [availableCard, setAvailableCards] = useState<any>();
  const [error, setError] = useState<any>(undefined);
  const [cardNumberError, setCardNumberError] = useState<boolean>(false);
  const [cardExpiryError, setCardExpiryError] = useState<boolean>(false);
  const [errorModal, setErrorModal] = useState<boolean>(false);
  const [cardCvcError, setCardCvcError] = useState<boolean>(false);
  const [cardNameError, setCardNameError] = useState<boolean>(false);
  const [showCouponSelectModal, setShowCouponSelectModal] =
    useState<boolean>(false);
  const [tokenId, setTokenId] = useState<string>("");
  const [purchaseList, setPurchaseList] = getPurchaseList;
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const parentTicketNumber = searchParams.get("parentTicketNumber")
    ? searchParams.get("parentTicketNumber")
    : "";
  const reservationTimeParam = searchParams.get("reservationTime")
    ? searchParams.get("reservationTime")
    : undefined;
  const supportTypeParam = searchParams.get("supportType")
    ? searchParams.get("supportType")
    : undefined;
  const reserveNowParam = searchParams.get("reserveNow")
    ? searchParams.get("reserveNow")
    : false;
  const staffIdParam = searchParams.get("staffId")
    ? searchParams.get("staffId")
    : false;
  const loadPayJp = useScript(`https://js.pay.jp/v2/`, {
    removeOnUnmount: true,
  });
  useEffect(() => {
    if (reserveNowParam) {
      const checkParams = checkReserveNowParams();
      console.log(checkParams);
      if (!checkParams) {
        navigate("/error?code=404");
      }
    }
  }, [reserveNowParam]);
  function checkReserveNowParams() {
    var regex = /^SUPPORT-\d{8}-\d{2}-\d{2}$/;
    if (!productId) {
      console.log("1");
      return false;
    }

    if (!reservationTimeParam) {
      console.log("2");
      return false;
    }
    if (reservationTimeParam && regex.test(reservationTimeParam) == false) {
      console.log("3");
      return false;
    } else {
      var ymd = reservationTimeParam?.split("-")[1];
      var hh = reservationTimeParam?.split("-")[2];
      var mm = reservationTimeParam?.split("-")[3];
      const fromFuture = isDateFromFuture(`${ymd}${hh}${mm}`);
      if (!fromFuture) {
        console.log("5");
        return false;
      }
    }
    if (!supportTypeParam) {
      console.log("6");
      return false;
    }
    if (supportTypeParam && !["ONLINE", "TEL"].includes(supportTypeParam)) {
      console.log("7");
      return false;
    }
    if (!staffIdParam) {
      console.log("8");
      return false;
    }
    return true;
  }
  useEffect(() => {
    document.title = "決済";
    if (!document.querySelector("#v2-mdc-card-number")) {
      return;
    }
    payjpfunc();
    if (Environment.getBuildType() != "prod") {
      console.log(chargeData);
    }
  }, [document.querySelector("#v2-mdc-card-number"), loadPayJp == "ready"]);
  useEffect(() => {
    if (useSavedCard === false) {
      payjpfunc();
    }
  }, [useSavedCard]);
  useEffect(() => {
    disableButton();
    changeCVV();
  }, [cardName, inputEvents, cardNameError]);
  useEffect(() => {
    if (inputEvents[0] && inputEvents[0].cardBrand && availableCard) {
      checkIfCardAcceptable();
    }
  }, [inputEvents[0] && inputEvents[0].cardBrand, availableCard]);

  useEffect(() => {
    if (chargeData) {
      if (chargeData.creditcard.cardId && useSavedCard) {
        setButtonClickable(true);
      }
      const cardListImages = setAvailableCardList(chargeData);
      setAvailableCards(cardListImages);
    }
  }, [chargeData]);
  function checkIfCardAcceptable() {
    if (availableCard.cardNames.includes(inputEvents[0].cardBrand)) {
    }
  }
  function payjpfunc() {
    var buttonElm: any = document.querySelector(".mdc-text-field");
    if (loadPayJp === "ready") {
      try {
        var payjp =
          getPayjpData && getPayjpData["payjp"] && getPayjpData["payjp"]._apiKey
            ? getPayjpData["payjp"]
            : Payjp(Environment.getPayjpId());
        var elements = payjp.elements();
        setButtonClickable(false);
        var elementStyle = {
          base: {
            "::placeholder": {
              color: "#D9D9D9",
              fontWeight: "600",
              fontSize: "16px",
            },
            lineHeight: "28px",
            height: "auto",
          },
          invalid: {
            color: "rgba(0, 0, 0, 0.87)",
          },
        };
        var numberElement = elements.create("cardNumber", {
          style: elementStyle,
          placeholder: "1234 1234 1234 1234",
        });
        var expiryElement = elements.create("cardExpiry", {
          style: elementStyle,
          placeholder: "MM（月） / YY（年）",
        });
        var cvcElement = elements.create("cardCvc", {
          style: elementStyle,
          placeholder: "000",
        });
        Promise.resolve([numberElement, expiryElement, cvcElement]).then(() => {
          numberElement.mount("#v2-mdc-card-number");
          expiryElement.mount("#v2-mdc-card-expiry");
          cvcElement.mount("#v2-mdc-card-cvc");
        });
        var payjpElements = [numberElement, expiryElement, cvcElement];
        var nameInput: any = document.querySelector("#v2-mdc-name");

        // 入力値のバリデーション結果を表示
        var changes = {};
        payjpElements.forEach(function (element, idx) {
          changes[idx] = null;
          element.on("change", function (event) {
            changes[idx] = event;
            handleInput(event);
            buttonElm.setAttribute("disabled", "true");
          });
        });
        setPayjpData({
          changes: changes,
          payjp: payjp,
          nameInput: nameInput,
          payjpElements: payjpElements,
        });
      } catch (err) {
        if (Environment.getBuildType() != "prod") {
          console.log(err);
        }
      }
    }
  }

  function handleInput(event: any) {
    var elementType: any = event.elementType;
    var eventComplete: any = event.complete;
    var eventError: any = event.error;
    var cardBrand: any = event.brand;
    var isAlreadyInArray: boolean = false;
    setInputEvents((oldData: any) => {
      oldData.map((data: any) => {
        if (data?.elementType == elementType) {
          data.eventComplete = eventComplete;
          data.eventError = eventError;
          data.cardBrand = cardBrand;
          isAlreadyInArray = true;
          return;
        }
      });
      if (!isAlreadyInArray) {
        return [
          ...oldData,
          { elementType, eventComplete, eventError, cardBrand },
        ];
      } else {
        return [...oldData];
      }
    });

    if (!eventComplete) {
      setButtonClickable(false);
    }
    showCardWarning(elementType, event.error);
    if (event.error) {
      if (event.elementType == "cardNumber") {
        setCardNumberError(true);
      }
      if (event.elementType == "cardExpiry") {
        setCardExpiryError(true);
      }
      if (event.elementType == "cardCvc") {
        setCardCvcError(true);
      }
    } else {
      setCardNumberError(false);
      setCardExpiryError(false);
      setCardCvcError(false);
    }
  }
  function showCardWarning(element: string, err: object) {
    var numberInput = document.querySelector("#v2-mdc-card-number");
    var expiryInput = document.querySelector("#v2-mdc-card-expiry");
    var cvcInput = document.querySelector("#v2-mdc-card-cvc");
    if (err) {
      setButtonClickable(false);
    }
    if (element == "cardNumber" && err) {
      numberInput?.classList.add("input-err");
    } else {
      numberInput?.classList.remove("input-err");
    }
    if (element == "cardExpiry" && err) {
      expiryInput?.classList.add("input-err");
    } else {
      expiryInput?.classList.remove("input-err");
    }
    if (element == "cardCvc" && err) {
      cvcInput?.classList.add("input-err");
    } else {
      cvcInput?.classList.remove("input-err");
    }
  }
  function disableButton() {
    if (
      cardName &&
      cardNameError == false &&
      inputEvents.length == 3 &&
      inputEvents[0].eventComplete &&
      inputEvents[1].eventComplete &&
      inputEvents[2].eventComplete
    ) {
      setButtonClickable(true);
    } else {
      setButtonClickable(false);
    }
  }
  function changeCVV() {
    if (inputEvents.length && inputEvents[0].cardBrand == "American Express") {
      setCvvDigits(4);
    } else {
      setCvvDigits(3);
    }
  }
  function validateCardName(name) {
    setCardName(name);
    setCardNameError(false);
    setCardNameError(!cardNameValid(name));
  }
  function validateCardNameOnChange(name) {
    setCardNameError(false);

    if (cardNameValid(name)) {
      setCardName(name);
    } else {
      setCardName(undefined);
    }
  }
  function handlePayjp(e: any, usePayjp: boolean) {
    e.preventDefault();
    if (loading) {
      return;
    }
    setLoading(true);
    if (cardNameError) {
      setLoading(false);
      return;
    }
    if (useSavedCard && chargeData.creditcard.cardId != "") {
      usePayjp = false;
    }
    if (usePayjp) {
      var changes = getPayjpData && getPayjpData["changes"];
      var payjp = getPayjpData && getPayjpData["payjp"];
      var nameInput = getPayjpData && getPayjpData["nameInput"];
      var payjpElements = getPayjpData && getPayjpData["payjpElements"];
      if (
        !Object.keys(changes)
          .sort()
          .reduce(function (prev, i) {
            return prev && changes[i] && changes[i].complete;
          }, true)
      ) {
        return;
      }

      var options = {
        card: {
          name: nameInput.value || undefined,
        },
      };

      payjp.createToken(payjpElements[0], options).then(function (result) {
        if (result.id) {
          // submitData(result.id, chargeData, state);
          setTokenId(result.id);
          console.log(chargeData);
          console.log(state);
          checkIfCouponSelected(result.id);
        } else {
          if (Environment.getBuildType() != "prod") {
            console.log(result);
          }
          setError(result.error.message);
          setErrorModal(true);
          setLoading(false);
        }
      });
    } else {
      // submitData("", chargeData, state);
      checkIfCouponSelected("");
    }
  }
  async function submitData(id) {
    setError(false);
    setErrorModal(false);
    setConcernTextError(false);
    var productData = chargeData.product;
    var reservationTime;
    if (reserveNowParam) {
      reservationTime = reservationTimeParam;
    } else {
      reservationTime = ["INTERVIEW", "TIP", "ADD"].includes(
        productData.productType
      )
        ? productData.productType
        : `${productData.productType}-${state.date}-${state.time}`;
    }
    var menuItems: any = [];
    if (!reserveNowParam) {
      if (state && state.ticket) {
        var obj = {
          menuId: state.ticket.productId,
          estimatedMinute: state.ticket.minutesToSupport,
          menuTitle: state.ticket.productName,
        };
        menuItems.push(obj);
      }
    } else {
      var obj = {
        menuId: productId,
        estimatedMinute: chargeData.product.minutesToSupport,
        menuTitle: chargeData.product.productName,
      };
      menuItems.push(obj);
    }
    var couponCode =
      couponData && couponData.data.couponAvailable
        ? couponData.couponCode
        : "";
    var supportType = buyType;
    if (reserveNowParam) {
      supportType = supportTypeParam;
    }
    var staffId;
    if (staffIdParam) {
      staffId = staffIdParam;
    } else {
      staffId = state && state.staffInfo.staffId ? state.staffInfo.staffId : "";
    }
    if (concernText.length > 500) {
      setError("500文字以内で入力してください。");
      setErrorModal(true);
      setLoading(false);
      setConcernTextError(true);
      return;
    }
    var params = {
      productId: productId,
      cardId: useSavedCard ? chargeData.creditcard.cardId : "",
      cardToken: id,
      saveCard: saveCard ? true : false,
      parentTicketNumber: parentTicketNumber,
      staffId: staffId,
      couponCode: couponCode,
      reservationTime: reservationTime,
      reservationMenuList: menuItems,
      supportType: supportType,
      reserveNow: reserveNowParam,
      counsellingComment: concernText,
    };
    if (Environment.getBuildType() != "prod") {
      console.log(params);
    }
    const request = () => {
      return httpPost({
        pathName: "charge",
        bodyParams: {
          ...params,
        },
      }).then((response: AxiosResponse<any>) => {
        var data = response.data;
        if (Environment.getBuildType() != "prod") {
          console.log(data);
        }
        if (response.status == 200) {
          getBuyType(chargeData?.product.productType);
          setPurchaseList(undefined);
          setUserData(undefined);
          navigate(`/buy-complete?type=${chargeData?.product.productType}`, {
            state: { couponCode: couponCode },
          });
        }
      });
    };
    try {
      await exponentialBackoff(request);
    } catch (error) {
      if (Environment.getBuildType() != "prod") {
        console.log(error);
      }
      if (error?.response?.status >= 400 && error?.response?.status <= 499) {
        if (
          error?.response?.data?.message.includes("STAFF_ASSING_DENY") ||
          error?.response?.data?.message.includes("STAFF_DENY")
        ) {
          if (!reserveNowParam) {
            navigate(`/support/staff?productId=${state.ticket.productId}`, {
              state: { displayToast: true, ...state },
            });
          } else {
            let ticket = {
              productType: supportTypeParam,
              minutesToSupport: chargeData.product.minutesToSupport,
              productName: chargeData.product.productName,
              productId: productId,
            };
            console.log(ticket);
            navigate(`/support/staff?productId=${state.ticket.productId}`, {
              state: { displayToast: true, ticket },
            });
          }
        }
      } else if (
        error?.response?.status >= 400 &&
        error?.response?.status <= 499 &&
        error?.response?.data?.message.includes("DENY_COUPON")
      ) {
        setError("クーポンが適用できません");
        setErrorModal(true);
        let newCouponData = getCouponData.couponList.filter((code) => {
          return code.couponCode != couponCode;
        });
        let obj = {
          couponList: newCouponData,
        };
        setCoupon(undefined);
        setCouponData(obj);
        // setCouponData(undefined);
        // fetchCoupon();
      } else {
        if (Environment.getBuildType() != "prod") {
          console.log(error);
        }
        setError(
          "決済に問題がありました。\nカード情報を確認後再度ご購入ください"
        );
        setErrorModal(true);
      }
    } finally {
      setLoading(false);
    }
  }
  function checkIfCouponExistsOnSelectedTicket() {
    return getCouponData.couponList.some((item) => {
      return item.availableProductList.some((product) => {
        if (
          product.productType == "SUPPORT" &&
          chargeData.product.productType == "SUPPORT"
        ) {
          return (
            product.minutesToSupport == chargeData.product.minutesToSupport
          );
        }
        return product.productType === chargeData.product.productType;
      });
    });
  }
  function checkIfCouponSelected(id) {
    if (
      chargeData &&
      getCouponData &&
      getCouponData.couponList?.length &&
      checkIfCouponExistsOnSelectedTicket() &&
      (couponData === undefined || couponData?.data.couponAvailable === false)
    ) {
      setShowCouponSelectModal(true);
    } else {
      submitData(id);
    }
  }
  const handleUseCoupon = () => {
    setLoading(false);
    setShowCouponSelectModal(false);
    document
      ?.getElementById("coupon-section")
      ?.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" });
  };

  const handleDontUseCoupon = () => {
    setShowCouponSelectModal(false);
    submitData(tokenId);
  };
  const handleCouponClose = () => {
    setLoading(false);
    setShowCouponSelectModal(false);
  };
  function getBuyType(buyType) {
    var eventName = "";
    if (buyType == "INTERVIEW") {
      eventName = "buyInterviewTicket";
    } else if (buyType == "ADD") {
      eventName = "buyAddTicket";
    } else if (buyType == "TIP") {
      eventName = "buyTip";
    } else if (buyType == "SUPPORT") {
      eventName = "buySupportTicket";
    }
    if (eventName == "buyTip") {
      setAnalyticsData({
        eventName: eventName,
        params: { price: chargeData?.product.price },
      });
    } else {
      setAnalyticsData({ eventName: eventName });
    }
  }
  return (
    <>
      {chargeData &&
      chargeData.creditcard &&
      chargeData.creditcard.cardId != "" &&
      useSavedCard ? (
        <SavedCard chargeData={chargeData} setUseSavedCard={setUseSavedCard} />
      ) : (
        <PayJpCardView
          cardNumberError={cardNumberError}
          availableCard={availableCard}
          cardExpiryError={cardExpiryError}
          cardCvcError={cardCvcError}
          cvvDigits={cvvDigits}
          setCardName={setCardName}
          setSaveCard={setSaveCard}
          chargeData={chargeData}
          setUseSavedCard={setUseSavedCard}
          setButtonClickable={setButtonClickable}
          cardNameError={cardNameError}
          validateCardName={validateCardName}
          validateCardNameOnChange={validateCardNameOnChange}
        />
      )}
      <PayjpBottom
        loading={loading}
        handlePayjp={handlePayjp}
        buttonClickable={buttonClickable}
        errorModal={errorModal}
        error={error}
        setErrorModal={setErrorModal}
        productType={chargeData?.product.productType}
        reserveNowParam={reserveNowParam}
        concernTextError={concernTextError}
      />
      {showCouponSelectModal && (
        <CouponSelectModal
          openModal={showCouponSelectModal}
          setOpenModal={setShowCouponSelectModal}
          handleUseCoupon={handleUseCoupon}
          handleDontUseCoupon={handleDontUseCoupon}
          handleCouponClose={handleCouponClose}
        />
      )}
    </>
  );
}

export default PayJp;
